/* ============================================================
   DEAD FLIGHT ARROWS — dfa-entete.js
   Tiroir mobile (focus trap + Escape) + compteur panier vivant.
   ============================================================ */
(function () {
  'use strict';

  class DfaEntete extends HTMLElement {
    connectedCallback() {
      this.tiroir = this.querySelector('[data-dfa-tiroir]');
      this.boutonOuvrir = this.querySelector('[data-dfa-ouvrir-tiroir]');
      this.boutonFermer = this.querySelector('[data-dfa-fermer-tiroir]');
      this.voile = this.querySelector('[data-dfa-voile]');
      this.compteur = this.querySelector('[data-dfa-compteur-panier]');

      this._surOuvrir = this.ouvrir.bind(this);
      this._surFermer = this.fermer.bind(this);
      this._surClavier = this.surClavier.bind(this);
      this._surPanier = this.surPanier.bind(this);

      if (this.boutonOuvrir) this.boutonOuvrir.addEventListener('click', this._surOuvrir);
      if (this.boutonFermer) this.boutonFermer.addEventListener('click', this._surFermer);
      if (this.voile) this.voile.addEventListener('click', this._surFermer);
      document.addEventListener('dfa:cart-updated', this._surPanier);
    }

    disconnectedCallback() {
      if (this.boutonOuvrir) this.boutonOuvrir.removeEventListener('click', this._surOuvrir);
      if (this.boutonFermer) this.boutonFermer.removeEventListener('click', this._surFermer);
      if (this.voile) this.voile.removeEventListener('click', this._surFermer);
      document.removeEventListener('dfa:cart-updated', this._surPanier);
      document.removeEventListener('keydown', this._surClavier);
    }

    ouvrir() {
      if (!this.tiroir) return;
      this.tiroir.dataset.ouvert = 'true';
      this.boutonOuvrir.setAttribute('aria-expanded', 'true');
      document.body.style.setProperty('--dfa-scroll-verrou', 'hidden');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._surClavier);
      var premier = this.tiroir.querySelector('button, a, input, [tabindex]:not([tabindex="-1"])');
      if (premier) premier.focus();
    }

    fermer() {
      if (!this.tiroir) return;
      this.tiroir.dataset.ouvert = 'false';
      this.boutonOuvrir.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._surClavier);
      this.boutonOuvrir.focus();
    }

    surClavier(e) {
      if (e.key === 'Escape') { this.fermer(); return; }
      if (e.key !== 'Tab') return;
      /* Focus trap */
      var focusables = this.tiroir.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var premier = focusables[0];
      var dernier = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    }

    surPanier(e) {
      if (!this.compteur || !e.detail) return;
      var n = e.detail.item_count;
      if (typeof n !== 'number') return;
      this.compteur.textContent = n;
      this.compteur.dataset.vide = n === 0 ? 'true' : 'false';
    }
  }

  if (!customElements.get('dfa-entete')) customElements.define('dfa-entete', DfaEntete);
})();
